var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "kirc" } },
    [
      _c("div", { staticClass: "particles" }),
      _vm._v(" "),
      _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
          },
          [
            _vm.showResult
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        _vm.showResult = false
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-size-80 md-medium-size-95 md-small-size-90 md-xsmall-size-90"
          },
          [
            _vm.showResult
              ? _c(
                  "md-card",
                  [
                    _c("md-card-content", [
                      _c(
                        "div",
                        {
                          staticClass: "md-layout oldhint",
                          class: "md-alignment-top-center",
                          staticStyle: { display: "block", width: "95%" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c("h1", [_vm._v("Alter KI-Readiness-Check")]),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Dies ist ein alter Readiness-Check. Bitte füllen Sie einen neuen aus:"
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-card-actions",
                      [
                        !_vm.loggedIn
                          ? _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-raised md-primary CTA CTA--Main",
                                attrs: { to: "/readinesscheck" }
                              },
                              [
                                _c("span", { staticClass: "buttonText" }, [
                                  _vm._v("Neuer Check")
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showResult
              ? _c(
                  "md-card",
                  [
                    _c("md-card-content", [
                      _c(
                        "div",
                        {
                          staticClass: "md-layout",
                          class: "md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-40 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "stickyHeading__Wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-display-1 kiReadinessLevel__H1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  KI-Readiness-Level\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("md-divider")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-card",
                                { staticClass: "CustomCard" },
                                [
                                  _c("md-card-content", [
                                    _c(
                                      "div",
                                      { staticClass: "progress-wrapper" },
                                      [
                                        _c("md-progress-spinner", {
                                          attrs: {
                                            align: "center",
                                            "md-diameter": 250,
                                            "md-stroke": 30,
                                            "md-mode": "determinate",
                                            "md-value":
                                              _vm.finalscore *
                                              0.2967359050445103857566765578635
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "finalScoreWrapper" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass: "levelSubheading"
                                              },
                                              [_vm._v("Level")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "h1",
                                              {
                                                staticClass: "mb-2",
                                                attrs: { id: "finalScore" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      Math.ceil(
                                                        _vm.finalscore / 68
                                                      ) + "/5"
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) === 1
                                              ? _c(
                                                  "h1",
                                                  {
                                                    attrs: {
                                                      slot: "textCard__Headline"
                                                    },
                                                    slot: "textCard__Headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level1.name
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) === 2
                                              ? _c(
                                                  "h1",
                                                  {
                                                    attrs: {
                                                      slot: "textCard__Headline"
                                                    },
                                                    slot: "textCard__Headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level2.name
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) === 3
                                              ? _c(
                                                  "h1",
                                                  {
                                                    attrs: {
                                                      slot: "textCard__Headline"
                                                    },
                                                    slot: "textCard__Headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level3.name
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) === 4
                                              ? _c(
                                                  "h1",
                                                  {
                                                    attrs: {
                                                      slot: "textCard__Headline"
                                                    },
                                                    slot: "textCard__Headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level4.name
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            Math.ceil(_vm.finalscore / 68) === 5
                                              ? _c(
                                                  "h1",
                                                  {
                                                    attrs: {
                                                      slot: "textCard__Headline"
                                                    },
                                                    slot: "textCard__Headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.level5.name
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("TextCard", [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "textCard__Icon" },
                                    slot: "textCard__Icon"
                                  },
                                  [_vm._v("info")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "textCard__Headline" },
                                    slot: "textCard__Headline"
                                  },
                                  [_vm._v("Ihre aktuelle Situation")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "textCard__Text" },
                                    slot: "textCard__Text"
                                  },
                                  [
                                    _c("p", { attrs: { align: "justify" } }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.kircResText) +
                                          "\n                  "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-60 md-medium-size-50 md-small-size-100 md-xsmall-size-100",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "stickyHeading__Wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-display-1 kiReadinessLevel__H1 left-align"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Empfehlungen\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.rec, function(item, key) {
                                return key !== "Abschließende Fragen"
                                  ? _c("TextCard", { key: key }, [
                                      key ==
                                      "Anwendungsbereiche und Technologien"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "textCard__Icon" },
                                              slot: "textCard__Icon"
                                            },
                                            [_vm._v("device_hub")]
                                          )
                                        : key ==
                                          "Prozesse, Strategie und Organisation"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "textCard__Icon" },
                                              slot: "textCard__Icon"
                                            },
                                            [_vm._v("assessment")]
                                          )
                                        : key == "Mitarbeiter"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "textCard__Icon" },
                                              slot: "textCard__Icon"
                                            },
                                            [_vm._v("person")]
                                          )
                                        : key ==
                                          "Wirtschaftliche Perspektive, Produkte und Dienstleistungen"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: { slot: "textCard__Icon" },
                                              slot: "textCard__Icon"
                                            },
                                            [_vm._v("business_center")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "textCard__Headline" },
                                          slot: "textCard__Headline"
                                        },
                                        [_vm._v(_vm._s(key))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "textCard__Text" },
                                          slot: "textCard__Text"
                                        },
                                        [
                                          item
                                            ? _c("p", [_vm._v(_vm._s(item))])
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _vm.recEvents.length > 0
                                ? _c("RecCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Icon" },
                                        slot: "recCard__Icon"
                                      },
                                      [_vm._v("calendar_today")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Headline" },
                                        slot: "recCard__Headline"
                                      },
                                      [_vm._v("Events")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "recCard__Content" },
                                        slot: "recCard__Content"
                                      },
                                      [
                                        _c(
                                          "md-table",
                                          _vm._l(_vm.recEvents, function(
                                            recevent,
                                            index
                                          ) {
                                            return _c(
                                              "md-table-row",
                                              { key: index.recevent },
                                              [
                                                _c("md-table-cell", [
                                                  _vm._v(_vm._s(recevent.name))
                                                ]),
                                                _vm._v(" "),
                                                _c("md-table-cell", [
                                                  _vm._v(
                                                    _vm._s(recevent.eventdate)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("md-table-cell", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: recevent.link,
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "md-button",
                                                        {
                                                          staticClass:
                                                            "md-accent eventBtn"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            Mehr Dazu\n                            "
                                                          ),
                                                          _c("md-icon", [
                                                            _vm._v(
                                                              "arrow_right_alt"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.recEvents.length == 0
                                ? _c("RecCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Icon" },
                                        slot: "recCard__Icon"
                                      },
                                      [_vm._v("calendar_today")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Headline" },
                                        slot: "recCard__Headline"
                                      },
                                      [_vm._v("Events")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "recCard__Content" },
                                        slot: "recCard__Content"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Derzeit können wir für Ihr Ergebnis leider keine\n                  Empfehlungen anzeigen\n                "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.recTrainer.length > 0
                                ? _c("RecCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Icon" },
                                        slot: "recCard__Icon"
                                      },
                                      [_vm._v("people")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Headline" },
                                        slot: "recCard__Headline"
                                      },
                                      [_vm._v("KI-Trainer")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "recCard__Content" },
                                        slot: "recCard__Content"
                                      },
                                      [
                                        _c(
                                          "md-table",
                                          _vm._l(_vm.recTrainer, function(
                                            rectrainer,
                                            index
                                          ) {
                                            return _c(
                                              "md-table-row",
                                              { key: index.rectrainer },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass: "no-link",
                                                    attrs: {
                                                      to:
                                                        "/trainerdetail/" +
                                                        rectrainer.hash,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "md-table-cell",
                                                      {
                                                        staticClass:
                                                          "ki-cell-small"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            rectrainer.name
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "md-table-cell",
                                                      {
                                                        staticClass:
                                                          "ki-cell-small"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            rectrainer.competence_center
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "md-table-cell",
                                                      {
                                                        staticClass:
                                                          "ki-cell-large"
                                                      },
                                                      _vm._l(
                                                        rectrainer.main_emphases,
                                                        function(
                                                          mainemphases,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "v-chip",
                                                            {
                                                              key:
                                                                index.mainemphases,
                                                              staticClass:
                                                                "ma-1",
                                                              attrs: {
                                                                small: "",
                                                                chip: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  mainemphases.name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.recTrainer.length == 0
                                ? _c("RecCard", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Icon" },
                                        slot: "recCard__Icon"
                                      },
                                      [_vm._v("people")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "recCard__Headline" },
                                        slot: "recCard__Headline"
                                      },
                                      [_vm._v("KI-Trainer")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "recCard__Content" },
                                        slot: "recCard__Content"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Derzeit können wir für Ihr Ergebnis leider keine\n                  Empfehlungen anzeigen\n                "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-card-actions",
                      [
                        !_vm.loggedIn
                          ? _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-raised md-primary CTA CTA--Main",
                                attrs: { to: "/readinesscheck" }
                              },
                              [
                                _c("span", { staticClass: "buttonText" }, [
                                  _vm._v("Neuer Check")
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.showResult
              ? _c(
                  "md-card",
                  [
                    _c("md-card-content", [
                      _c(
                        "div",
                        {
                          staticClass: "md-layout",
                          class: "md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                              class: "md-alignment-top-center"
                            },
                            [
                              _c("div", { staticClass: "headlineWrapper" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-display-1 mainHeadline" },
                                  [
                                    _vm._v(
                                      "\n                  Sie haben einen alten Readiness Check. Hier Ihren alten Ergebniscode erneut eingeben:\n                "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                [
                                  _c("label", [
                                    _vm._v("KI-Readiness-Check Ergebniscode")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    model: {
                                      value: _vm.code,
                                      callback: function($$v) {
                                        _vm.code = $$v
                                      },
                                      expression: "code"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "md-card-actions",
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-raised md-primary CTA CTA--Main",
                            attrs: { to: "" },
                            on: {
                              click: function($event) {
                                return _vm.getResult()
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "buttonText" }, [
                              _vm._v("Ergebnis laden")
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.error
                      ? _c("h4", [
                          _vm._v(
                            "\n          Dieser Ergebniscode ist uns nicht bekannt. Bitte starten Sie einen\n          neuen KI-Readiness-Check\n        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", {
          staticClass:
            "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
        })
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-5 md-medium-size-10 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": false,
          "is-full-page": true
        },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c83c9a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c83c9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/result/KIRCRes.vue
// module id = null
// module chunks = 